import React from 'react';
import Products from '../../Components/home/Products/Products';
import Bestseller from '../../Components/home/Bestseller/Bestseller';
import Carousel from '../../Components/home/Carousel/Carousel'
import About from '../../Components/home/About/About';
import Category from '../../Components/home/Category/Category';
import Photos from '../../Components/home/Photos/Photos';
import Blogs from '../../Components/home/Blogs/Blogs';
import Contact from '../../Components/home/Contact/Contact';



const Home = () => {
  return (
    <> 
    <Carousel/>
    <Category/>
    <Bestseller/>
    <Photos/>
    <About/>
    <Products/>
    <Blogs/>
    <Contact/>

    
    </>
  )
}

export default Home;
